import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { BsBag } from "react-icons/bs";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cartCount = cartItems ? cartItems.length : 0;

  return (
    <header className="site-header">
      <div className="top-banner">
        <div className="banner-content">
          <span>Free Shipping on All Orders | No Minimum*</span>
        </div>
      </div>

      <div className="main-nav">
        <div className="nav-left">
          <Link onClick={toTop} to="/" className="logo-link">
            <span className="logo-text">
              Parkhaven<sup className="reg-mark">&reg;</sup>
            </span>
          </Link>

          <nav className="nav-links">
            <Link onClick={toTop} to="/about" className="nav-link">
              Our story
            </Link>

            <Link onClick={toTop} to="/shop" className="nav-link">
              Sale
            </Link>
            <Link onClick={toTop} to="/contact" className="nav-link">
              Help
            </Link>
          </nav>
        </div>

        <div className="nav-right">
          <Link onClick={toTop} to="/cartpage" className="cart-link">
            <div className="cart-icon-wrapper">
              <BsBag className="bag-icon" />
              <span className="cart-count">{cartCount}</span>
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
